"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SinglePhoneNumber = void 0;
var react_1 = __importDefault(require("react"));
var LimitTextField_1 = require("./LimitTextField");
var styles_1 = require("@material-ui/core/styles");
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Radio_1 = __importDefault(require("@material-ui/core/Radio"));
var RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
var strings_1 = __importDefault(require("../strings"));
var utils_1 = require("../utils");
var useStyles = styles_1.makeStyles(function (theme) {
    var _a, _b;
    return ({
        error: {
            color: "Red",
            marginTop: theme.spacing(-2),
        },
        canText: (_a = {
                display: "flex",
                alignItems: "end"
            },
            _a[theme.breakpoints.down("md")] = {
                paddingTop: "0px !important",
            },
            _a),
        field: (_b = {},
            _b[theme.breakpoints.down("md")] = {
                paddingBottom: "0px !important",
            },
            _b),
    });
});
var SinglePhoneNumber = function (props) {
    var classes = useStyles(props);
    var getCanText = function () {
        if (!props.showCanTextRadioButtons)
            return undefined;
        return props.canText;
    };
    var _a = react_1.default.useState(props.phoneNumber || ""), number = _a[0], setNumber = _a[1];
    var _b = react_1.default.useState(getCanText()), canText = _b[0], setCanText = _b[1];
    react_1.default.useEffect(function () {
        setNumber(props.phoneNumber || "");
        setCanText(getCanText());
    }, [props.phoneNumber, props.canText, props.showCanTextRadioButtons]);
    var handleChangeNumber = function (e) {
        var newNumber = number;
        var regexPattern = /^[0-9-+()]*$/;
        if (e.target.value === "" || regexPattern.test(e.target.value)) {
            newNumber = e.target.value;
        }
        props.onChange(newNumber, canText);
    };
    var handleBlurNumber = function (e) {
        props.onChange(utils_1.phoneNumber(e.target.value), canText);
    };
    var handleCanTextChange = function (e) {
        var text = props.showCanTextRadioButtons ? e.target.value === "true" : e.target.checked;
        props.onChange(number, text);
    };
    var renderNumber = function () {
        var singleError = props.error;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 12, md: 4, lg: 3, className: classes.field },
                react_1.default.createElement(LimitTextField_1.LimitTextField, { floatingLabel: props.floatingLabel, error: singleError, id: (props.name || "pn") + "_single_phone", key: (props.name || "pn") + "_single_phone", name: "single_phone_number", variant: "outlined", size: "small", fullWidth: true, disabled: !!props.readOnly, limit: 16, showCount: false, label: props.label, value: number, onChange: handleChangeNumber, onBlur: handleBlurNumber, style: props.style, autoFocus: props.autoFocus })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 12, md: 6, lg: 6, className: props.showCanTextRadioButtons ? classes.canText : undefined },
                props.showCanTextRadioButtons &&
                    (react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(RadioGroup_1.default, { row: true, name: "can-text-radio", onChange: handleCanTextChange, value: canText === null || canText === void 0 ? void 0 : canText.toString() },
                            react_1.default.createElement(FormControlLabel_1.default, { value: "true", control: react_1.default.createElement(Radio_1.default, null), label: strings_1.default.phoneNumbers.sms }),
                            react_1.default.createElement(FormControlLabel_1.default, { value: "false", control: react_1.default.createElement(Radio_1.default, null), label: strings_1.default.phoneNumbers.landline }))), label: props.showCanTextRadioButtons ? undefined : strings_1.default.phoneNumbers.canText })),
                props.showCanText &&
                    (react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Checkbox_1.default, { checked: canText, onChange: handleCanTextChange, disabled: !!props.readOnly, name: "cantext", color: "primary" })), label: strings_1.default.phoneNumbers.canText })))));
    };
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 3 },
        renderNumber(),
        !!props.error && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement("div", { className: classes.error }, strings_1.default.phoneNumbers.errorMessageSingle)))));
};
exports.SinglePhoneNumber = SinglePhoneNumber;
